export const SCROLLBAR_ORIENTATION_VERTICAL = 'SCROLLBAR_ORIENTATION_VERTICAL';
export const SCROLLBAR_ORIENTATION_HORIZONTAL = 'SCROLLBAR_ORIENTATION_HORIZONTAL';
